export const texts = {
  es: {
    title: "Validá tu dirección de mail",
    subtitle: "El código es válido durante 24 horas",
    primaryButton: "Continuar",
    secondaryButton: "Volver",
    body: "Ingresá el token que enviamos a",
    resendText: "Reenviar mail",
    incorrectTokenErrorMessage: "El token es incorrecto.",
    lengthValidationErrorMessage: "Deben ser 7 caracteres.",
    errorMessage:
      "El token es invalido o ha expirado. Solicitá uno nuevo para continuar.",
  },
  en: {
    title: "Validate your email address",
    subtitle: "The code is valid for 24 hours",
    primaryButton: "Continue",
    secondaryButton: "Back",
    body: "Enter the token we sent to",
    resendText: "Resend email",
    incorrectTokenErrorMessage: "Incorrect token.",
    lengthValidationErrorMessage: "Has to be 7 characters long.",
    errorMessage:
      "The token is invalid or has expired. Request a new one to continue",
  },
};
